// extracted by mini-css-extract-plugin
export default {"container":"PaymentReporting_container__8AtsE"};